/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BulkWorkingHoursDTO } from '../models';
// @ts-ignore
import type { CalendarCreateDTO } from '../models';
// @ts-ignore
import type { CalendarResponseDTO } from '../models';
// @ts-ignore
import type { CalendarUpdateDTO } from '../models';
// @ts-ignore
import type { EventResponseDTO } from '../models';
// @ts-ignore
import type { EventTypeResponseDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageCalendarResponseDTO } from '../models';
// @ts-ignore
import type { WorkingHoursCreateDTO } from '../models';
// @ts-ignore
import type { WorkingHoursEventTypeAssignmentDTO } from '../models';
// @ts-ignore
import type { WorkingHoursResponseDTO } from '../models';
// @ts-ignore
import type { WorkingHoursUpdateDTO } from '../models';
/**
 * CalendarsApi - axios parameter creator
 * @export
 */
export const CalendarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a single event type to working hours. This adds to existing assignments without removing others. Requires \'calendar:write\' permission.
         * @summary Add Event Type To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost: async (calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost', 'workingHoursId', workingHoursId)
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost', 'eventTypeId', eventTypeId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}/event-types/{event_type_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)))
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a single event type to working hours. This adds to existing assignments without removing others. Requires \'calendar:write\' permission.
         * @summary Add Event Type To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1: async (calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1', 'workingHoursId', workingHoursId)
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1', 'eventTypeId', eventTypeId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}/event-types/{event_type_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)))
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk assign event types to a working hours period. This replaces all existing assignments. Requires \'calendar:write\' permission.
         * @summary Assign Event Types To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursEventTypeAssignmentDTO} workingHoursEventTypeAssignmentDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut: async (calendarId: string, workingHoursId: string, workingHoursEventTypeAssignmentDTO: WorkingHoursEventTypeAssignmentDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut', 'workingHoursId', workingHoursId)
            // verify required parameter 'workingHoursEventTypeAssignmentDTO' is not null or undefined
            assertParamExists('assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut', 'workingHoursEventTypeAssignmentDTO', workingHoursEventTypeAssignmentDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}/event-types`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workingHoursEventTypeAssignmentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk assign event types to a working hours period. This replaces all existing assignments. Requires \'calendar:write\' permission.
         * @summary Assign Event Types To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursEventTypeAssignmentDTO} workingHoursEventTypeAssignmentDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2: async (calendarId: string, workingHoursId: string, workingHoursEventTypeAssignmentDTO: WorkingHoursEventTypeAssignmentDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2', 'workingHoursId', workingHoursId)
            // verify required parameter 'workingHoursEventTypeAssignmentDTO' is not null or undefined
            assertParamExists('assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2', 'workingHoursEventTypeAssignmentDTO', workingHoursEventTypeAssignmentDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}/event-types`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workingHoursEventTypeAssignmentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new calendar in the current organization. Requires \'calendar:write\' permission.
         * @summary Create Calendar
         * @param {CalendarCreateDTO} calendarCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarApiV1CalendarsPost: async (calendarCreateDTO: CalendarCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarCreateDTO' is not null or undefined
            assertParamExists('createCalendarApiV1CalendarsPost', 'calendarCreateDTO', calendarCreateDTO)
            const localVarPath = `/api/v1/calendars/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new calendar in the current organization. Requires \'calendar:write\' permission.
         * @summary Create Calendar
         * @param {CalendarCreateDTO} calendarCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarApiV1CalendarsPost_3: async (calendarCreateDTO: CalendarCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarCreateDTO' is not null or undefined
            assertParamExists('createCalendarApiV1CalendarsPost_3', 'calendarCreateDTO', calendarCreateDTO)
            const localVarPath = `/api/v1/calendars/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Create Working Hours
         * @param {string} calendarId 
         * @param {WorkingHoursCreateDTO} workingHoursCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost: async (calendarId: string, workingHoursCreateDTO: WorkingHoursCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost', 'calendarId', calendarId)
            // verify required parameter 'workingHoursCreateDTO' is not null or undefined
            assertParamExists('createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost', 'workingHoursCreateDTO', workingHoursCreateDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workingHoursCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Create Working Hours
         * @param {string} calendarId 
         * @param {WorkingHoursCreateDTO} workingHoursCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4: async (calendarId: string, workingHoursCreateDTO: WorkingHoursCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4', 'calendarId', calendarId)
            // verify required parameter 'workingHoursCreateDTO' is not null or undefined
            assertParamExists('createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4', 'workingHoursCreateDTO', workingHoursCreateDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workingHoursCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a calendar from the organization. Requires \'calendar:write\' permission.
         * @summary Delete Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarApiV1CalendarsCalendarIdDelete: async (calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('deleteCalendarApiV1CalendarsCalendarIdDelete', 'calendarId', calendarId)
            const localVarPath = `/api/v1/calendars/{calendar_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a calendar from the organization. Requires \'calendar:write\' permission.
         * @summary Delete Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarApiV1CalendarsCalendarIdDelete_5: async (calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('deleteCalendarApiV1CalendarsCalendarIdDelete_5', 'calendarId', calendarId)
            const localVarPath = `/api/v1/calendars/{calendar_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Delete Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete: async (calendarId: string, workingHoursId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete', 'workingHoursId', workingHoursId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Delete Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6: async (calendarId: string, workingHoursId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6', 'workingHoursId', workingHoursId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific calendar by ID. Requires \'calendar:view\' permission.
         * @summary Get Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarApiV1CalendarsCalendarIdGet: async (calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('getCalendarApiV1CalendarsCalendarIdGet', 'calendarId', calendarId)
            const localVarPath = `/api/v1/calendars/{calendar_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific calendar by ID. Requires \'calendar:view\' permission.
         * @summary Get Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarApiV1CalendarsCalendarIdGet_7: async (calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('getCalendarApiV1CalendarsCalendarIdGet_7', 'calendarId', calendarId)
            const localVarPath = `/api/v1/calendars/{calendar_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get events for a specific calendar, optionally filtered by date range. Requires \'event:view\' permission.
         * @summary Get Calendar Events
         * @param {string} calendarId 
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventsApiV1CalendarsCalendarIdEventsGet: async (calendarId: string, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('getCalendarEventsApiV1CalendarsCalendarIdEventsGet', 'calendarId', calendarId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/events`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get events for a specific calendar, optionally filtered by date range. Requires \'event:view\' permission.
         * @summary Get Calendar Events
         * @param {string} calendarId 
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventsApiV1CalendarsCalendarIdEventsGet_8: async (calendarId: string, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('getCalendarEventsApiV1CalendarsCalendarIdEventsGet_8', 'calendarId', calendarId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/events`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get working hours for a calendar with assigned event types. Requires \'calendar:view\' permission.
         * @summary Get Working Hours
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet: async (calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet', 'calendarId', calendarId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get working hours for a calendar with assigned event types. Requires \'calendar:view\' permission.
         * @summary Get Working Hours
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet_9: async (calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet_9', 'calendarId', calendarId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all event types assigned to a working hours period. Requires \'calendar:view\' permission.
         * @summary Get Working Hours Event Types
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet: async (calendarId: string, workingHoursId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet', 'workingHoursId', workingHoursId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}/event-types`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all event types assigned to a working hours period. Requires \'calendar:view\' permission.
         * @summary Get Working Hours Event Types
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10: async (calendarId: string, workingHoursId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10', 'workingHoursId', workingHoursId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}/event-types`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all calendars in the current user\'s organization. Requires \'calendar:view\' permission.
         * @summary List Calendars
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarsApiV1CalendarsGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/calendars/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all calendars in the current user\'s organization. Requires \'calendar:view\' permission.
         * @summary List Calendars
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarsApiV1CalendarsGet_11: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/calendars/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a single event type from working hours. Requires \'calendar:write\' permission.
         * @summary Remove Event Type From Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete: async (calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete', 'workingHoursId', workingHoursId)
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete', 'eventTypeId', eventTypeId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}/event-types/{event_type_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)))
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a single event type from working hours. Requires \'calendar:write\' permission.
         * @summary Remove Event Type From Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12: async (calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12', 'workingHoursId', workingHoursId)
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12', 'eventTypeId', eventTypeId)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}/event-types/{event_type_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)))
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace all working hours for a calendar with new ones. Requires \'calendar:write\' permission.
         * @summary Replace All Working Hours
         * @param {string} calendarId 
         * @param {BulkWorkingHoursDTO} bulkWorkingHoursDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut: async (calendarId: string, bulkWorkingHoursDTO: BulkWorkingHoursDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut', 'calendarId', calendarId)
            // verify required parameter 'bulkWorkingHoursDTO' is not null or undefined
            assertParamExists('replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut', 'bulkWorkingHoursDTO', bulkWorkingHoursDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkWorkingHoursDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace all working hours for a calendar with new ones. Requires \'calendar:write\' permission.
         * @summary Replace All Working Hours
         * @param {string} calendarId 
         * @param {BulkWorkingHoursDTO} bulkWorkingHoursDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13: async (calendarId: string, bulkWorkingHoursDTO: BulkWorkingHoursDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13', 'calendarId', calendarId)
            // verify required parameter 'bulkWorkingHoursDTO' is not null or undefined
            assertParamExists('replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13', 'bulkWorkingHoursDTO', bulkWorkingHoursDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkWorkingHoursDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a calendar\'s information. Requires \'calendar:write\' permission.
         * @summary Update Calendar
         * @param {string} calendarId 
         * @param {CalendarUpdateDTO} calendarUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarApiV1CalendarsCalendarIdPatch: async (calendarId: string, calendarUpdateDTO: CalendarUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('updateCalendarApiV1CalendarsCalendarIdPatch', 'calendarId', calendarId)
            // verify required parameter 'calendarUpdateDTO' is not null or undefined
            assertParamExists('updateCalendarApiV1CalendarsCalendarIdPatch', 'calendarUpdateDTO', calendarUpdateDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a calendar\'s information. Requires \'calendar:write\' permission.
         * @summary Update Calendar
         * @param {string} calendarId 
         * @param {CalendarUpdateDTO} calendarUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarApiV1CalendarsCalendarIdPatch_14: async (calendarId: string, calendarUpdateDTO: CalendarUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('updateCalendarApiV1CalendarsCalendarIdPatch_14', 'calendarId', calendarId)
            // verify required parameter 'calendarUpdateDTO' is not null or undefined
            assertParamExists('updateCalendarApiV1CalendarsCalendarIdPatch_14', 'calendarUpdateDTO', calendarUpdateDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Update Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursUpdateDTO} workingHoursUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch: async (calendarId: string, workingHoursId: string, workingHoursUpdateDTO: WorkingHoursUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch', 'workingHoursId', workingHoursId)
            // verify required parameter 'workingHoursUpdateDTO' is not null or undefined
            assertParamExists('updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch', 'workingHoursUpdateDTO', workingHoursUpdateDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workingHoursUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Update Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursUpdateDTO} workingHoursUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15: async (calendarId: string, workingHoursId: string, workingHoursUpdateDTO: WorkingHoursUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15', 'calendarId', calendarId)
            // verify required parameter 'workingHoursId' is not null or undefined
            assertParamExists('updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15', 'workingHoursId', workingHoursId)
            // verify required parameter 'workingHoursUpdateDTO' is not null or undefined
            assertParamExists('updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15', 'workingHoursUpdateDTO', workingHoursUpdateDTO)
            const localVarPath = `/api/v1/calendars/{calendar_id}/working-hours/{working_hours_id}`
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"working_hours_id"}}`, encodeURIComponent(String(workingHoursId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workingHoursUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarsApi - functional programming interface
 * @export
 */
export const CalendarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalendarsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a single event type to working hours. This adds to existing assignments without removing others. Requires \'calendar:write\' permission.
         * @summary Add Event Type To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost(calendarId, workingHoursId, eventTypeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a single event type to working hours. This adds to existing assignments without removing others. Requires \'calendar:write\' permission.
         * @summary Add Event Type To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1(calendarId, workingHoursId, eventTypeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk assign event types to a working hours period. This replaces all existing assignments. Requires \'calendar:write\' permission.
         * @summary Assign Event Types To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursEventTypeAssignmentDTO} workingHoursEventTypeAssignmentDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut(calendarId: string, workingHoursId: string, workingHoursEventTypeAssignmentDTO: WorkingHoursEventTypeAssignmentDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut(calendarId, workingHoursId, workingHoursEventTypeAssignmentDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk assign event types to a working hours period. This replaces all existing assignments. Requires \'calendar:write\' permission.
         * @summary Assign Event Types To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursEventTypeAssignmentDTO} workingHoursEventTypeAssignmentDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2(calendarId: string, workingHoursId: string, workingHoursEventTypeAssignmentDTO: WorkingHoursEventTypeAssignmentDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2(calendarId, workingHoursId, workingHoursEventTypeAssignmentDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new calendar in the current organization. Requires \'calendar:write\' permission.
         * @summary Create Calendar
         * @param {CalendarCreateDTO} calendarCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalendarApiV1CalendarsPost(calendarCreateDTO: CalendarCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarApiV1CalendarsPost(calendarCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.createCalendarApiV1CalendarsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new calendar in the current organization. Requires \'calendar:write\' permission.
         * @summary Create Calendar
         * @param {CalendarCreateDTO} calendarCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalendarApiV1CalendarsPost_3(calendarCreateDTO: CalendarCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarApiV1CalendarsPost_3(calendarCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.createCalendarApiV1CalendarsPost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Create Working Hours
         * @param {string} calendarId 
         * @param {WorkingHoursCreateDTO} workingHoursCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost(calendarId: string, workingHoursCreateDTO: WorkingHoursCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHoursResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost(calendarId, workingHoursCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Create Working Hours
         * @param {string} calendarId 
         * @param {WorkingHoursCreateDTO} workingHoursCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4(calendarId: string, workingHoursCreateDTO: WorkingHoursCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHoursResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4(calendarId, workingHoursCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a calendar from the organization. Requires \'calendar:write\' permission.
         * @summary Delete Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalendarApiV1CalendarsCalendarIdDelete(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCalendarApiV1CalendarsCalendarIdDelete(calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.deleteCalendarApiV1CalendarsCalendarIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a calendar from the organization. Requires \'calendar:write\' permission.
         * @summary Delete Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalendarApiV1CalendarsCalendarIdDelete_5(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCalendarApiV1CalendarsCalendarIdDelete_5(calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.deleteCalendarApiV1CalendarsCalendarIdDelete_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Delete Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete(calendarId, workingHoursId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Delete Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6(calendarId, workingHoursId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific calendar by ID. Requires \'calendar:view\' permission.
         * @summary Get Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarApiV1CalendarsCalendarIdGet(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarApiV1CalendarsCalendarIdGet(calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.getCalendarApiV1CalendarsCalendarIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific calendar by ID. Requires \'calendar:view\' permission.
         * @summary Get Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarApiV1CalendarsCalendarIdGet_7(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarApiV1CalendarsCalendarIdGet_7(calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.getCalendarApiV1CalendarsCalendarIdGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get events for a specific calendar, optionally filtered by date range. Requires \'event:view\' permission.
         * @summary Get Calendar Events
         * @param {string} calendarId 
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarEventsApiV1CalendarsCalendarIdEventsGet(calendarId: string, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarEventsApiV1CalendarsCalendarIdEventsGet(calendarId, startDate, endDate, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.getCalendarEventsApiV1CalendarsCalendarIdEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get events for a specific calendar, optionally filtered by date range. Requires \'event:view\' permission.
         * @summary Get Calendar Events
         * @param {string} calendarId 
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarEventsApiV1CalendarsCalendarIdEventsGet_8(calendarId: string, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarEventsApiV1CalendarsCalendarIdEventsGet_8(calendarId, startDate, endDate, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.getCalendarEventsApiV1CalendarsCalendarIdEventsGet_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get working hours for a calendar with assigned event types. Requires \'calendar:view\' permission.
         * @summary Get Working Hours
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet(calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get working hours for a calendar with assigned event types. Requires \'calendar:view\' permission.
         * @summary Get Working Hours
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet_9(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet_9(calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all event types assigned to a working hours period. Requires \'calendar:view\' permission.
         * @summary Get Working Hours Event Types
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet(calendarId, workingHoursId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all event types assigned to a working hours period. Requires \'calendar:view\' permission.
         * @summary Get Working Hours Event Types
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10(calendarId, workingHoursId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all calendars in the current user\'s organization. Requires \'calendar:view\' permission.
         * @summary List Calendars
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCalendarsApiV1CalendarsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCalendarResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCalendarsApiV1CalendarsGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.listCalendarsApiV1CalendarsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all calendars in the current user\'s organization. Requires \'calendar:view\' permission.
         * @summary List Calendars
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCalendarsApiV1CalendarsGet_11(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCalendarResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCalendarsApiV1CalendarsGet_11(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.listCalendarsApiV1CalendarsGet_11']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a single event type from working hours. Requires \'calendar:write\' permission.
         * @summary Remove Event Type From Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete(calendarId, workingHoursId, eventTypeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a single event type from working hours. Requires \'calendar:write\' permission.
         * @summary Remove Event Type From Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12(calendarId, workingHoursId, eventTypeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace all working hours for a calendar with new ones. Requires \'calendar:write\' permission.
         * @summary Replace All Working Hours
         * @param {string} calendarId 
         * @param {BulkWorkingHoursDTO} bulkWorkingHoursDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut(calendarId: string, bulkWorkingHoursDTO: BulkWorkingHoursDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut(calendarId, bulkWorkingHoursDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace all working hours for a calendar with new ones. Requires \'calendar:write\' permission.
         * @summary Replace All Working Hours
         * @param {string} calendarId 
         * @param {BulkWorkingHoursDTO} bulkWorkingHoursDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13(calendarId: string, bulkWorkingHoursDTO: BulkWorkingHoursDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13(calendarId, bulkWorkingHoursDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a calendar\'s information. Requires \'calendar:write\' permission.
         * @summary Update Calendar
         * @param {string} calendarId 
         * @param {CalendarUpdateDTO} calendarUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendarApiV1CalendarsCalendarIdPatch(calendarId: string, calendarUpdateDTO: CalendarUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarApiV1CalendarsCalendarIdPatch(calendarId, calendarUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.updateCalendarApiV1CalendarsCalendarIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a calendar\'s information. Requires \'calendar:write\' permission.
         * @summary Update Calendar
         * @param {string} calendarId 
         * @param {CalendarUpdateDTO} calendarUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendarApiV1CalendarsCalendarIdPatch_14(calendarId: string, calendarUpdateDTO: CalendarUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarApiV1CalendarsCalendarIdPatch_14(calendarId, calendarUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.updateCalendarApiV1CalendarsCalendarIdPatch_14']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Update Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursUpdateDTO} workingHoursUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch(calendarId: string, workingHoursId: string, workingHoursUpdateDTO: WorkingHoursUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHoursResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch(calendarId, workingHoursId, workingHoursUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Update Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursUpdateDTO} workingHoursUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15(calendarId: string, workingHoursId: string, workingHoursUpdateDTO: WorkingHoursUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHoursResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15(calendarId, workingHoursId, workingHoursUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarsApi.updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalendarsApi - factory interface
 * @export
 */
export const CalendarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalendarsApiFp(configuration)
    return {
        /**
         * Add a single event type to working hours. This adds to existing assignments without removing others. Requires \'calendar:write\' permission.
         * @summary Add Event Type To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTypeResponseDTO>> {
            return localVarFp.addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost(calendarId, workingHoursId, eventTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a single event type to working hours. This adds to existing assignments without removing others. Requires \'calendar:write\' permission.
         * @summary Add Event Type To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTypeResponseDTO>> {
            return localVarFp.addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1(calendarId, workingHoursId, eventTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk assign event types to a working hours period. This replaces all existing assignments. Requires \'calendar:write\' permission.
         * @summary Assign Event Types To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursEventTypeAssignmentDTO} workingHoursEventTypeAssignmentDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut(calendarId: string, workingHoursId: string, workingHoursEventTypeAssignmentDTO: WorkingHoursEventTypeAssignmentDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTypeResponseDTO>> {
            return localVarFp.assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut(calendarId, workingHoursId, workingHoursEventTypeAssignmentDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk assign event types to a working hours period. This replaces all existing assignments. Requires \'calendar:write\' permission.
         * @summary Assign Event Types To Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursEventTypeAssignmentDTO} workingHoursEventTypeAssignmentDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2(calendarId: string, workingHoursId: string, workingHoursEventTypeAssignmentDTO: WorkingHoursEventTypeAssignmentDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTypeResponseDTO>> {
            return localVarFp.assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2(calendarId, workingHoursId, workingHoursEventTypeAssignmentDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new calendar in the current organization. Requires \'calendar:write\' permission.
         * @summary Create Calendar
         * @param {CalendarCreateDTO} calendarCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarApiV1CalendarsPost(calendarCreateDTO: CalendarCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarResponseDTO> {
            return localVarFp.createCalendarApiV1CalendarsPost(calendarCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new calendar in the current organization. Requires \'calendar:write\' permission.
         * @summary Create Calendar
         * @param {CalendarCreateDTO} calendarCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarApiV1CalendarsPost_3(calendarCreateDTO: CalendarCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarResponseDTO> {
            return localVarFp.createCalendarApiV1CalendarsPost_3(calendarCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Create Working Hours
         * @param {string} calendarId 
         * @param {WorkingHoursCreateDTO} workingHoursCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost(calendarId: string, workingHoursCreateDTO: WorkingHoursCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponseDTO> {
            return localVarFp.createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost(calendarId, workingHoursCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Create Working Hours
         * @param {string} calendarId 
         * @param {WorkingHoursCreateDTO} workingHoursCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4(calendarId: string, workingHoursCreateDTO: WorkingHoursCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponseDTO> {
            return localVarFp.createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4(calendarId, workingHoursCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a calendar from the organization. Requires \'calendar:write\' permission.
         * @summary Delete Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarApiV1CalendarsCalendarIdDelete(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCalendarApiV1CalendarsCalendarIdDelete(calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a calendar from the organization. Requires \'calendar:write\' permission.
         * @summary Delete Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarApiV1CalendarsCalendarIdDelete_5(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCalendarApiV1CalendarsCalendarIdDelete_5(calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Delete Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete(calendarId, workingHoursId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Delete Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6(calendarId, workingHoursId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific calendar by ID. Requires \'calendar:view\' permission.
         * @summary Get Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarApiV1CalendarsCalendarIdGet(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarResponseDTO> {
            return localVarFp.getCalendarApiV1CalendarsCalendarIdGet(calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific calendar by ID. Requires \'calendar:view\' permission.
         * @summary Get Calendar
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarApiV1CalendarsCalendarIdGet_7(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarResponseDTO> {
            return localVarFp.getCalendarApiV1CalendarsCalendarIdGet_7(calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get events for a specific calendar, optionally filtered by date range. Requires \'event:view\' permission.
         * @summary Get Calendar Events
         * @param {string} calendarId 
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventsApiV1CalendarsCalendarIdEventsGet(calendarId: string, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventResponseDTO>> {
            return localVarFp.getCalendarEventsApiV1CalendarsCalendarIdEventsGet(calendarId, startDate, endDate, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get events for a specific calendar, optionally filtered by date range. Requires \'event:view\' permission.
         * @summary Get Calendar Events
         * @param {string} calendarId 
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventsApiV1CalendarsCalendarIdEventsGet_8(calendarId: string, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventResponseDTO>> {
            return localVarFp.getCalendarEventsApiV1CalendarsCalendarIdEventsGet_8(calendarId, startDate, endDate, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get working hours for a calendar with assigned event types. Requires \'calendar:view\' permission.
         * @summary Get Working Hours
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponseDTO>> {
            return localVarFp.getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet(calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get working hours for a calendar with assigned event types. Requires \'calendar:view\' permission.
         * @summary Get Working Hours
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet_9(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponseDTO>> {
            return localVarFp.getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet_9(calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all event types assigned to a working hours period. Requires \'calendar:view\' permission.
         * @summary Get Working Hours Event Types
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTypeResponseDTO>> {
            return localVarFp.getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet(calendarId, workingHoursId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all event types assigned to a working hours period. Requires \'calendar:view\' permission.
         * @summary Get Working Hours Event Types
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTypeResponseDTO>> {
            return localVarFp.getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10(calendarId, workingHoursId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all calendars in the current user\'s organization. Requires \'calendar:view\' permission.
         * @summary List Calendars
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarsApiV1CalendarsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCalendarResponseDTO> {
            return localVarFp.listCalendarsApiV1CalendarsGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all calendars in the current user\'s organization. Requires \'calendar:view\' permission.
         * @summary List Calendars
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarsApiV1CalendarsGet_11(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCalendarResponseDTO> {
            return localVarFp.listCalendarsApiV1CalendarsGet_11(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a single event type from working hours. Requires \'calendar:write\' permission.
         * @summary Remove Event Type From Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete(calendarId, workingHoursId, eventTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a single event type from working hours. Requires \'calendar:write\' permission.
         * @summary Remove Event Type From Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12(calendarId, workingHoursId, eventTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace all working hours for a calendar with new ones. Requires \'calendar:write\' permission.
         * @summary Replace All Working Hours
         * @param {string} calendarId 
         * @param {BulkWorkingHoursDTO} bulkWorkingHoursDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut(calendarId: string, bulkWorkingHoursDTO: BulkWorkingHoursDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponseDTO>> {
            return localVarFp.replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut(calendarId, bulkWorkingHoursDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace all working hours for a calendar with new ones. Requires \'calendar:write\' permission.
         * @summary Replace All Working Hours
         * @param {string} calendarId 
         * @param {BulkWorkingHoursDTO} bulkWorkingHoursDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13(calendarId: string, bulkWorkingHoursDTO: BulkWorkingHoursDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponseDTO>> {
            return localVarFp.replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13(calendarId, bulkWorkingHoursDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a calendar\'s information. Requires \'calendar:write\' permission.
         * @summary Update Calendar
         * @param {string} calendarId 
         * @param {CalendarUpdateDTO} calendarUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarApiV1CalendarsCalendarIdPatch(calendarId: string, calendarUpdateDTO: CalendarUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarResponseDTO> {
            return localVarFp.updateCalendarApiV1CalendarsCalendarIdPatch(calendarId, calendarUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a calendar\'s information. Requires \'calendar:write\' permission.
         * @summary Update Calendar
         * @param {string} calendarId 
         * @param {CalendarUpdateDTO} calendarUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarApiV1CalendarsCalendarIdPatch_14(calendarId: string, calendarUpdateDTO: CalendarUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarResponseDTO> {
            return localVarFp.updateCalendarApiV1CalendarsCalendarIdPatch_14(calendarId, calendarUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Update Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursUpdateDTO} workingHoursUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch(calendarId: string, workingHoursId: string, workingHoursUpdateDTO: WorkingHoursUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponseDTO> {
            return localVarFp.updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch(calendarId, workingHoursId, workingHoursUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update working hours for a calendar. Requires \'calendar:write\' permission.
         * @summary Update Working Hours
         * @param {string} calendarId 
         * @param {string} workingHoursId 
         * @param {WorkingHoursUpdateDTO} workingHoursUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15(calendarId: string, workingHoursId: string, workingHoursUpdateDTO: WorkingHoursUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponseDTO> {
            return localVarFp.updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15(calendarId, workingHoursId, workingHoursUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarsApi - object-oriented interface
 * @export
 * @class CalendarsApi
 * @extends {BaseAPI}
 */
export class CalendarsApi extends BaseAPI {
    /**
     * Add a single event type to working hours. This adds to existing assignments without removing others. Requires \'calendar:write\' permission.
     * @summary Add Event Type To Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {string} eventTypeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost(calendarId, workingHoursId, eventTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a single event type to working hours. This adds to existing assignments without removing others. Requires \'calendar:write\' permission.
     * @summary Add Event Type To Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {string} eventTypeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).addEventTypeToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdPost_1(calendarId, workingHoursId, eventTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk assign event types to a working hours period. This replaces all existing assignments. Requires \'calendar:write\' permission.
     * @summary Assign Event Types To Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {WorkingHoursEventTypeAssignmentDTO} workingHoursEventTypeAssignmentDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut(calendarId: string, workingHoursId: string, workingHoursEventTypeAssignmentDTO: WorkingHoursEventTypeAssignmentDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut(calendarId, workingHoursId, workingHoursEventTypeAssignmentDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk assign event types to a working hours period. This replaces all existing assignments. Requires \'calendar:write\' permission.
     * @summary Assign Event Types To Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {WorkingHoursEventTypeAssignmentDTO} workingHoursEventTypeAssignmentDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2(calendarId: string, workingHoursId: string, workingHoursEventTypeAssignmentDTO: WorkingHoursEventTypeAssignmentDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).assignEventTypesToWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesPut_2(calendarId, workingHoursId, workingHoursEventTypeAssignmentDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new calendar in the current organization. Requires \'calendar:write\' permission.
     * @summary Create Calendar
     * @param {CalendarCreateDTO} calendarCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public createCalendarApiV1CalendarsPost(calendarCreateDTO: CalendarCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).createCalendarApiV1CalendarsPost(calendarCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new calendar in the current organization. Requires \'calendar:write\' permission.
     * @summary Create Calendar
     * @param {CalendarCreateDTO} calendarCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public createCalendarApiV1CalendarsPost_3(calendarCreateDTO: CalendarCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).createCalendarApiV1CalendarsPost_3(calendarCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create working hours for a calendar. Requires \'calendar:write\' permission.
     * @summary Create Working Hours
     * @param {string} calendarId 
     * @param {WorkingHoursCreateDTO} workingHoursCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost(calendarId: string, workingHoursCreateDTO: WorkingHoursCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost(calendarId, workingHoursCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create working hours for a calendar. Requires \'calendar:write\' permission.
     * @summary Create Working Hours
     * @param {string} calendarId 
     * @param {WorkingHoursCreateDTO} workingHoursCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4(calendarId: string, workingHoursCreateDTO: WorkingHoursCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).createWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPost_4(calendarId, workingHoursCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a calendar from the organization. Requires \'calendar:write\' permission.
     * @summary Delete Calendar
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public deleteCalendarApiV1CalendarsCalendarIdDelete(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).deleteCalendarApiV1CalendarsCalendarIdDelete(calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a calendar from the organization. Requires \'calendar:write\' permission.
     * @summary Delete Calendar
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public deleteCalendarApiV1CalendarsCalendarIdDelete_5(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).deleteCalendarApiV1CalendarsCalendarIdDelete_5(calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete working hours for a calendar. Requires \'calendar:write\' permission.
     * @summary Delete Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete(calendarId, workingHoursId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete working hours for a calendar. Requires \'calendar:write\' permission.
     * @summary Delete Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).deleteWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdDelete_6(calendarId, workingHoursId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific calendar by ID. Requires \'calendar:view\' permission.
     * @summary Get Calendar
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getCalendarApiV1CalendarsCalendarIdGet(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).getCalendarApiV1CalendarsCalendarIdGet(calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific calendar by ID. Requires \'calendar:view\' permission.
     * @summary Get Calendar
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getCalendarApiV1CalendarsCalendarIdGet_7(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).getCalendarApiV1CalendarsCalendarIdGet_7(calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get events for a specific calendar, optionally filtered by date range. Requires \'event:view\' permission.
     * @summary Get Calendar Events
     * @param {string} calendarId 
     * @param {string | null} [startDate] Start date for event filtering (ISO format)
     * @param {string | null} [endDate] End date for event filtering (ISO format)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getCalendarEventsApiV1CalendarsCalendarIdEventsGet(calendarId: string, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).getCalendarEventsApiV1CalendarsCalendarIdEventsGet(calendarId, startDate, endDate, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get events for a specific calendar, optionally filtered by date range. Requires \'event:view\' permission.
     * @summary Get Calendar Events
     * @param {string} calendarId 
     * @param {string | null} [startDate] Start date for event filtering (ISO format)
     * @param {string | null} [endDate] End date for event filtering (ISO format)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getCalendarEventsApiV1CalendarsCalendarIdEventsGet_8(calendarId: string, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).getCalendarEventsApiV1CalendarsCalendarIdEventsGet_8(calendarId, startDate, endDate, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get working hours for a calendar with assigned event types. Requires \'calendar:view\' permission.
     * @summary Get Working Hours
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet(calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get working hours for a calendar with assigned event types. Requires \'calendar:view\' permission.
     * @summary Get Working Hours
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet_9(calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).getWorkingHoursApiV1CalendarsCalendarIdWorkingHoursGet_9(calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all event types assigned to a working hours period. Requires \'calendar:view\' permission.
     * @summary Get Working Hours Event Types
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet(calendarId, workingHoursId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all event types assigned to a working hours period. Requires \'calendar:view\' permission.
     * @summary Get Working Hours Event Types
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10(calendarId: string, workingHoursId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).getWorkingHoursEventTypesApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesGet_10(calendarId, workingHoursId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all calendars in the current user\'s organization. Requires \'calendar:view\' permission.
     * @summary List Calendars
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public listCalendarsApiV1CalendarsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).listCalendarsApiV1CalendarsGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all calendars in the current user\'s organization. Requires \'calendar:view\' permission.
     * @summary List Calendars
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public listCalendarsApiV1CalendarsGet_11(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).listCalendarsApiV1CalendarsGet_11(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a single event type from working hours. Requires \'calendar:write\' permission.
     * @summary Remove Event Type From Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {string} eventTypeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete(calendarId, workingHoursId, eventTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a single event type from working hours. Requires \'calendar:write\' permission.
     * @summary Remove Event Type From Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {string} eventTypeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12(calendarId: string, workingHoursId: string, eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).removeEventTypeFromWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdEventTypesEventTypeIdDelete_12(calendarId, workingHoursId, eventTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace all working hours for a calendar with new ones. Requires \'calendar:write\' permission.
     * @summary Replace All Working Hours
     * @param {string} calendarId 
     * @param {BulkWorkingHoursDTO} bulkWorkingHoursDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut(calendarId: string, bulkWorkingHoursDTO: BulkWorkingHoursDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut(calendarId, bulkWorkingHoursDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace all working hours for a calendar with new ones. Requires \'calendar:write\' permission.
     * @summary Replace All Working Hours
     * @param {string} calendarId 
     * @param {BulkWorkingHoursDTO} bulkWorkingHoursDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13(calendarId: string, bulkWorkingHoursDTO: BulkWorkingHoursDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).replaceAllWorkingHoursApiV1CalendarsCalendarIdWorkingHoursPut_13(calendarId, bulkWorkingHoursDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a calendar\'s information. Requires \'calendar:write\' permission.
     * @summary Update Calendar
     * @param {string} calendarId 
     * @param {CalendarUpdateDTO} calendarUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public updateCalendarApiV1CalendarsCalendarIdPatch(calendarId: string, calendarUpdateDTO: CalendarUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).updateCalendarApiV1CalendarsCalendarIdPatch(calendarId, calendarUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a calendar\'s information. Requires \'calendar:write\' permission.
     * @summary Update Calendar
     * @param {string} calendarId 
     * @param {CalendarUpdateDTO} calendarUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public updateCalendarApiV1CalendarsCalendarIdPatch_14(calendarId: string, calendarUpdateDTO: CalendarUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).updateCalendarApiV1CalendarsCalendarIdPatch_14(calendarId, calendarUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update working hours for a calendar. Requires \'calendar:write\' permission.
     * @summary Update Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {WorkingHoursUpdateDTO} workingHoursUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch(calendarId: string, workingHoursId: string, workingHoursUpdateDTO: WorkingHoursUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch(calendarId, workingHoursId, workingHoursUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update working hours for a calendar. Requires \'calendar:write\' permission.
     * @summary Update Working Hours
     * @param {string} calendarId 
     * @param {string} workingHoursId 
     * @param {WorkingHoursUpdateDTO} workingHoursUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15(calendarId: string, workingHoursId: string, workingHoursUpdateDTO: WorkingHoursUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CalendarsApiFp(this.configuration).updateWorkingHoursApiV1CalendarsCalendarIdWorkingHoursWorkingHoursIdPatch_15(calendarId, workingHoursId, workingHoursUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

